module.exports = __webpack_public_path__ + "img/datacomm.930b1dfd.png";